import React from 'react';
import PropTypes from 'prop-types';

import VariantInputGroup from 'bento-ordering/base/components/VariantInputGroup';

/**
 * This is variant component that needs to be used
 * as a component prop in redux-form.
 */
const VariantInputGroupField = props => {
  const {
    title,
    input,
    fieldType,
    list,
    checked,
    required,
    disabled,
    selectionSatisfied,
    helperText
  } = props;
  return (
    <VariantInputGroup
      title={title}
      helperText={helperText}
      fieldType={fieldType}
      onChange={value => input.onChange(value)}
      value={input.value || {}}
      list={list}
      checked={checked}
      required={required}
      disabled={disabled}
      selectionSatisfied={selectionSatisfied}
    />
  );
};

VariantInputGroupField.propTypes = {
  title: PropTypes.string,
  input: PropTypes.object,
  fieldType: PropTypes.string,
  list: PropTypes.array,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  selectionSatisfied: PropTypes.bool,
  helperText: PropTypes.string
};

export default VariantInputGroupField;
